import { createSelector } from '@ngrx/store';

import { ShoppingState, getShoppingState } from 'ish-core/store/shopping/shopping-store';

import { customSearchAdapter } from './custom-search.reducer';

const getCustomSearchState = createSelector(getShoppingState, (state: ShoppingState) => state.customSearch);

const { selectEntities: getCustomSuggestSearchEntities } = customSearchAdapter.getSelectors(getCustomSearchState);

export const getCustomSuggestSearchResults = (searchTerm: string) =>
  createSelector(getCustomSuggestSearchEntities, entities => entities[searchTerm]?.suggests || []);
